// SaveScrollPosition.tsx

import { useEffect } from "react";

const useSaveScrollPosition = (
    ref: React.RefObject<HTMLElement>,
    session: string
) => {
    useEffect(() => {
        const saveScrollPosition = () => {
            if (ref.current) {
                sessionStorage.setItem(
                    session,
                    ref.current.scrollTop.toString()
                );
            }
        };

        if (ref.current) {
            ref.current.addEventListener("scroll", saveScrollPosition);
        }

        return () => {
            if (ref.current) {
                ref.current.removeEventListener("scroll", saveScrollPosition);
                saveScrollPosition();
            }
        };
    }, [ref]);
};

export default useSaveScrollPosition;
